import { useSelector } from "react-redux";
import { Flex } from "rebass";
import SummaryTableRow from "../cart/SummaryTableRow";
import { getLocalizedString } from "../../utils";
import useResponsive from "../../hooks/useResponsive";

const DoorDetailSummary = ({
  doorCode,
  reorder,
  swap,
  defaultExpanded = false,
}) => {
  const { customer } = useSelector((state) => state.yodaCustomer);

  const { shippingCost } = useSelector((state) => state.yodaOrders);

  const doorShippingCost =
    shippingCost?.find?.((costItem) => costItem?.customerDoorId === doorCode)
      ?.shippingCost || 0;
  const doorCost =
    (isNaN(reorder?.doorPrice) ? 0 : reorder?.doorPrice) -
    (isNaN(swap?.doorPrice) ? 0 : swap?.doorPrice) +
    doorShippingCost;
  const doorReorderQuantity = Object.values(
    reorder?.quantityDetails || {},
  ).reduce?.((prev, qty) => prev + qty, 0);
  const doorSwapQuantity = Object.values(swap?.quantityDetails || {}).reduce?.(
    (prev, qty) => prev + qty,
    0,
  );

  const { breakpoint } = useResponsive();

  return (
    <Flex style={{ width: "100%" }} flexDirection="column">
      <SummaryTableRow
        name={
          <>
            DOOR{" "}
            <strong>
              {customer?.doors?.find?.((door) => door.id === doorCode)?.code ||
                ""}
              {" - "}
              {customer?.doors?.find?.((door) => door.id === doorCode)?.name ||
                ""}
            </strong>
          </>
        }
        {...{
          price: doorCost || 0,
          qty: doorReorderQuantity + doorSwapQuantity,
          sx: { backgroundColor: "#787878", fontSize: ".9em" },
          defaultExpanded,
          detail: (
            <>
              <SummaryTableRow
                {...{
                  name: getLocalizedString("REORDER"),
                  price: reorder?.doorPrice || 0,
                  labelPadding: "12px",
                  qty: doorReorderQuantity,
                  sx: { backgroundColor: "#787878", fontSize: ".9em" },
                  detail: Object.keys(reorder?.collectionMap)?.map?.((e, i) => {
                    return (
                      <SummaryTableRow
                        key={`door-product-${i}-${reorder?.collectionMap?.[e]?.["it"]}`}
                        secondary
                        {...{
                          name: reorder?.collectionMap?.[e]?.["it"],
                          qty: reorder?.quantityDetails?.[e] || 0,
                          price: reorder?.priceDetails?.[e] || 0,
                        }}
                      />
                    );
                  }),
                }}
              />
              {swap && (
                <SummaryTableRow
                  {...{
                    name: getLocalizedString("SWAP_TAB"),
                    price: swap?.doorPrice || 0,
                    labelPadding: "12px",
                    qty: doorSwapQuantity,
                    detail: Object.keys(swap?.collectionMap)?.map?.((e, i) => {
                      return (
                        <SummaryTableRow
                          key={`door-product-${i}-${swap.collectionMap?.[e]?.["it"]}`}
                          secondary
                          {...{
                            name: swap.collectionMap?.[e]?.["it"],
                            qty: swap.quantityDetails?.[e] || 0,
                            price: swap.priceDetails?.[e] || 0,
                          }}
                        />
                      );
                    }),
                  }}
                />
              )}
              <SummaryTableRow
                secondary
                {...{
                  name: getLocalizedString("Spese di spedizione"),
                  price: doorShippingCost || 0,
                  qty: null,
                }}
              />
              <SummaryTableRow
                total
                {...{
                  name:
                    swap?.doorPrice > 0
                      ? getLocalizedString("TotalOrderSwap")
                      : getLocalizedString("TotalDoor"),
                  price: doorCost,
                  qty: null,
                }}
                sx={{
                  background: "#a1a1a1",
                  marginBottom: breakpoint(["10px", "20px"]),
                }}
              />
            </>
          ),
        }}
      />
    </Flex>
  );
};

export { DoorDetailSummary };
